export const getToastPosition = (position) => {
  switch (position) {
    case 'top-left': return { top: '24px', left: '24px' };
    case 'top-right': return { top: '24px', right: '24px' };
    case 'bottom-left': return { bottom: '24px', left: '24px' };
    case 'bottom-right': return { bottom: '24px', right: '24px' };
    case 'top-center': return { top: '24px', left: '50%', transform: 'translateX(-50%)' };
    case 'bottom-center': return { bottom: '24px', left: '50%', transform: 'translateX(-50%)' };
    default: return { top: '24px', right: '24px' };
  }
};

export const getToastVariantStyles = (type, theme) => {
  const colors = theme && theme.colors ? theme.colors : { feedback: { success: '#28a745', error: '#dc3545', warning: '#ffc107', info: '#17a2b8' } };
  switch (type) {
    case 'success': return { bg: colors.feedback.success, color: '#fff' };
    case 'danger':
    case 'error': return { bg: colors.feedback.error, color: '#fff' };
    case 'warning': return { bg: colors.feedback.warning, color: '#000' };
    case 'info':
    default: return { bg: colors.feedback.info, color: '#fff' };
  }
};



// WEBPACK FOOTER //
// ./src/design-system/molecules/Toast/utils/toastHelpers.js